<div class="row">
  <div class="col">
    <div *ngIf="operativeHistoryLoading" class="text-center">
      <fa-duotone-icon [icon]="['fad', 'spinner']" [spin]="true" [pulse]="true" size="4x" primaryColor="darkgreen" secondaryColor="green"></fa-duotone-icon>
    </div>
    <div *ngIf="!operativeHistoryLoading">
      <p-table [totalRecords]="engagementHistory?.length" #tt [value]="engagementHistory"
               [globalFilterFields]="['jobTitle.name','jobLevel.name', 'employmentStatus.name', 'risk.name', 'to.dateTime', 'from.dateTime', 'riskMatrixLevel']" dataKey="id"
               styleClass="p-datatable-striped p-datatable-responsive-eca"
               [scrollable]="!isOnMobile &&    engagementHistory?.length > 5" scrollHeight="500px"
               [responsive]="true" [columns]="columns">
        <ng-container>
          <ng-template pTemplate="caption">
            <div class="row d-flex justify-content-between align-items-center">
              <div class=" col-xl-auto col-lg-auto col-md-6 col-sm-12">
                <div class="row  justify-content-lg-start justify-content-md-start justify-content-sm-between justify-content-between align-items-center">
                  <div class="col-auto">
                    <h5 class="eca-primary-text">
                      <span *ngIf="engagementHistory"> {{ engagementHistory.length }}</span>
                      Roles
                    </h5>
                  </div>
                  <div class="col-auto">
                    <app-eca-ghost-btn (btnClicked)="addHistoryEntry()" [btnText]="addButtonText" *ngIf="allowOperations?.canInsert"
                                       btnIcon="plus-circle" btnType="success">
                    </app-eca-ghost-btn>
                  </div>
                </div>
              </div>
              <div class=" col-xl-auto col-lg-auto col-md-6 col-sm-12 ">
                <div class="row  justify-content-lg-start justify-content-md-end justify-content-sm-between justify-content-between align-items-center">
                  <div class="col-xl-auto col-lg-auto col-md-8 col-sm-8 col-6">
                    <span class="p-input-icon-left">
                      <i class="pi pi-search"></i>
                      <input pInputText type="text" class="form-control" id="ctrlOperativeHistorySearchInput"
                             placeholder="Search All"
                             (input)="tt.filterGlobal($event.target.value, 'contains')">
                    </span>
                  </div>
                  <div class="col-auto">
                    <app-eca-ghost-btn btnIcon="file-excel" btnText="Export" btnType="primary" (btnClicked)="exportToExcel()"></app-eca-ghost-btn>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </ng-container>
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 10%" pSortableColumn="from.dateTime">
              From
              <p-sortIcon field="from.dateTime"></p-sortIcon>
            </th>
            <th style="width: 10%" pSortableColumn="to.dateTime">
              To
              <p-sortIcon field="to.dateTime"></p-sortIcon>
            </th>
            <th style="width: 15%" pSortableColumn="businessUnit.name">
              Business Unit
              <p-sortIcon field="businessUnit.name"></p-sortIcon>
            </th>
            <th style="width: 15%" pSortableColumn="operativeType.name">
              Operative Type
              <p-sortIcon field="operativeType.name"></p-sortIcon>
            </th>
            <th style="width: 15%" pSortableColumn="jobTitle.name">
              Job Role
              <p-sortIcon field="jobTitle.name"></p-sortIcon>
            </th>
            <th style="width: 15%" pSortableColumn="risk.name">
              Work Risk
              <p-sortIcon field="risk.name"></p-sortIcon>
            </th>
            <th style="width: 15%" pSortableColumn="jobLevel.name">
              Job Level
              <p-sortIcon field="jobLevel.name"></p-sortIcon>
            </th>
            <!--<th style="width: 15%" pSortableColumn="employmentStatus.name">
              Employment Status
              <p-sortIcon field="employmentStatus.name"></p-sortIcon>
            </th>-->
            <th style="width: 15%" pSortableColumn="riskMatrixLevel">
              Supervision
              <p-sortIcon field="riskMatrixLevel"></p-sortIcon>
            </th>
            <th style="width: 10%"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-history let-columns="columns">
          <tr [style.color]="getEngagementRiskColour(history)">
            <td *ngFor="let col of columns">
              <span class="p-column-title">{{col.header}}: </span>
              <label>
                <span *ngIf="col.type=== 'text'">
                  {{history[col.field]?.name}}
                </span>
                <span *ngIf="col.type === 'date'">
                  {{history[col.field]?.dateTime | date:'dd/MM/yyyy'}}
                </span>
                <span *ngIf="col.type === 'enum'">
                  <span *ngIf="history['jobTitle']?.name ==='Qualified Supervisor'">QS</span>
                  <span *ngIf="history['jobTitle']?.name !=='Qualified Supervisor'">
                    {{ degreeOfSupervisionString[history[col.field]] }}
                  </span>
                </span>
              </label>
            </td>
            <td>
              <app-eca-row-menu (viewBtnClicked)="viewEngagement(history)"
                                [rowMenuVisible]="allowOperations?.canDelete && engagementHistory?.length > 1"
                                [rowMenuItems]="rowMenuItems"
                                [contextItem]="history">
              </app-eca-row-menu>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
